import { render } from "./TitleAiCrateView.vue?vue&type=template&id=db390170"
import script from "./TitleAiCrateView.vue?vue&type=script&lang=js"
export * from "./TitleAiCrateView.vue?vue&type=script&lang=js"

import "./TitleAiCrateView.vue?vue&type=style&index=0&id=db390170&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__